import axios from "../containers/api";

export const toEnglishNumbers = (input) => {
  if (!(input === undefined || input === null)) {
    return input.toString().replace(/۰/g, "0")
        .replace(/۱/g, "1")
        .replace(/۲/g, "2")
        .replace(/۳/g, "3")
        .replace(/۴/g, "4")
        .replace(/۵/g, "5")
        .replace(/۶/g, "6")
        .replace(/۷/g, "7")
        .replace(/۸/g, "8")
        .replace(/۹/g, "9");
  }
};

export const convertDate = (date) => {
  if (date === null || date === "" || date.length === 0) {
    return "";
  }
  let y = date.year.toString();
  let m = date.month.toString().length < 2 ? "0".concat(date.month.toString()) : date.month.toString();
  let d = date.day.toString().length < 2 ? "0".concat(date.day.toString()) : date.day.toString();
  return y.concat("/", m, "/", d);
};
export const convertDateToDatepicker = (date, isReserve = false) => {
  let dateString = "";
  if (!isReserve) {
    dateString = date.split("/");
  } else {
    dateString = date.split(":");
  }

  let month = parseInt(dateString[1]);
  if (month < 10) {
    month = parseInt(dateString[1].replace(0, ""));
  }
  let day = parseInt(dateString[2]);
  if (day < 10) {
    day = parseInt(dateString[2].replace(0, ""));
  }

  return {year: parseInt(dateString[0]), month: month, day: day};
};
export const getDayBefore = () => {
  let today = new Date();
  let date1 = today.getDate() - 1;
  today.setFullYear(today.getFullYear(), today.getMonth(), date1);
  let date4 = today.toLocaleDateString('fa-IR');
  let date5 = date4.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728));

  return {
    day: parseInt(date5.split('/')[2]),
    month: parseInt(date5.split('/')[1]),
    year: parseInt(date5.split('/')[0])
  };
};

//export const showCatchError = (error) => {
//  console.log(error.response)
//  if (error.response) {
//    if (error.response.data && typeof error.response.data !== undefined && error.response.data.message) {
//      return error.response.data.message;
//    } else if (error.response.data && typeof error.response.data !== undefined) {
//      return error.response.data;
//    } else {
//      return "اتصالی با سرور ایجاد نشد!";
//    }
//  } else {
//    return "اتصالی با سرور ایجاد نشد!";
//  }
//};
//export const showCatchError = (error) => {
//    console.log(error.response);

//    if (error.response) {
//        const data = error.response.data;

//        if (data) {
//            // اگه error وجود داشت، اون رو هم ضمیمه کن
//            if (data.errors && data.errors.length > 0) {
//                return `${data.message || "خطا"} - ${data.errors.join(" | ")}`;
//            }

//            // در غیر این صورت فقط message
//            if (data.message) {
//                return data.message;
//            }

//            // fallback
//            return data;
//        }

//        return "اتصالی با سرور ایجاد نشد!";
//    }

//    return "اتصالی با سرور ایجاد نشد!";
//};

export const showCatchError = (error) => {
    console.log(error.response);

    if (error.response) {
        const data = error.response.data;

        if (data) {
            // اگر errors آبجکت بود
            if (data.errors) {
                const messages = Object.values(data.errors).flat().join(" | ");
                return messages;
            }

            // اگر message داشت
            if (data.message) {
                return data.message;
            }

            // fallback → title (مثلاً "One or more validation errors occurred.")
            if (data.title) {
                return data.title;
            }

            return "خطای ناشناخته سمت سرور";
        }

        return "اتصالی با سرور ایجاد نشد!";
    }

    return "اتصالی با سرور ایجاد نشد!";
};

export const toCurrency = (Number) => {
  if (Number === undefined || Number === null) {
    return "";
  } else {
    Number += '';
    Number = Number.replace(',', '');
    Number = Number.replace(',', '');
    Number = Number.replace(',', '');
    Number = Number.replace(',', '');
    Number = Number.replace(',', '');
    Number = Number.replace(',', '');
    let x = Number.split('.');
    let y = x[0];
    let z = x.length > 1 ? '.' + x[1] : '';
    let rgx = /([0-9۰-۹]+)([0-9۰-۹]{3})/;
    while (rgx.test(y))
      y = y.replace(rgx, '$1,$2');
    return y + z;
  }
};

export function getBastebandys() {
  let Bastebandys = sessionStorage.getItem("Bastebandys");
  if (Bastebandys === null || Bastebandys === undefined) {
      return axios.get("/api/v1/bastebandies/GetAllBastebandy")
        .then((res) => {
          sessionStorage.setItem("Bastebandys", JSON.stringify(res.data));
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
  } else {
    return new Promise(resolve => {
      resolve(JSON.parse(Bastebandys));
    });
  }
}


export function getkalas() {
  let kalas = sessionStorage.getItem("kalas");
  if (kalas === null || kalas === undefined) {
      return axios.get("/api/v1/kalas/GetAllKala")
        .then((res) => {
            sessionStorage.setItem("kalas", JSON.stringify(res.data));
            console.log(res.data)
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
  } else {
    return new Promise(resolve => {
      resolve(JSON.parse(kalas));
    });
  }
}

export function getLoaderTypes() {
  let LoaderTypes = sessionStorage.getItem("LoaderTypes");

  if (LoaderTypes === null || LoaderTypes === undefined) {
      return axios.get("/api/v1/loader-types/GetAllLoaderType")
        .then((res) => {
            sessionStorage.setItem("LoaderTypes", JSON.stringify(res.data));  
            return res.data;
            
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
  } else {
    return new Promise(resolve => {
      resolve(JSON.parse(LoaderTypes));
    });
  }
}
export function GetDistinctLoaderTypes() {
    let DistinctLoaderTypes = sessionStorage.getItem("DistinctLoaderTypes");

    if (DistinctLoaderTypes === null || DistinctLoaderTypes === undefined) {
        return axios.get("/api/v1/loader-types/GetDistinctLoaderType")
        .then((res) => {
            sessionStorage.setItem("DistinctLoaderTypes", JSON.stringify(res.data));
          return res.data;
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
  } else {
    return new Promise(resolve => {
        resolve(JSON.parse(DistinctLoaderTypes));
    });
  }
}

export function getCheckMemberTypeIsAdmin (showSpinner, hideSpinner) {
  showSpinner();
  return axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
      .then((res) => {
        hideSpinner();
        return (res.data);
      })
      .catch((error) => {
        hideSpinner();
        console.log(error);
        return false;
      });
}

export const getDurationHour = (distance, duration) => {
  let kilometer= (distance / 1000).toFixed();
  let  hour= (duration / 3600).toFixed()
  return {
    hour, kilometer
  }
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];
    if (order.indexOf(A + "") > order.indexOf(B + "")) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};


export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '.' + mm + '.' + yyyy;
}

export const getCurrentTime=()=>{
  const now = new Date();
  return now.getHours() + ":" + now.getMinutes()
}




